import React from 'react';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import PropTypes from 'prop-types';

export default class RadioField extends React.Component {
    render() {
        const {
            id,
            title,
            options,
            emptyValue,
            error,
            errorText,
            helperText,
            required,
            disabled,
            inputValue,
            onBlur,
            onFocus,
            valueOptions,
            uiSchema
        } = this.props;

        const { classes = {} } = uiSchema;
        const onChange = ({ target: { value } }) => {
            this.props.onChange(id, value === '' ? emptyValue : value);
        };

        const radios = [];

        valueOptions.forEach((valueOption, i) => {
            const { key, label } = valueOption;
            const optionDisabled = disabled ? disabled : valueOption.disabled;

            radios.push(
                <FormControlLabel
                    classes={{
                        root: classes.formControlLabel
                    }}
                    key={ `checkbox-${id}-${i}` }
                    value={ key }
                    disabled={ optionDisabled }
                    control={
                        <Radio
                            classes={{
                                root: classes.radio
                            }}
                            inputProps={{
                                'data-cy': `${id}-radio-field`
                            }}
                        />
                    }
                    labelPlacement={ options.labelPlacement }
                    label={ label }
                />
            );
        });

        return (
            <React.Fragment>
                <FormControl
                    required={ required }
                    error={ error }
                    component="fieldset"
                    classes={{
                        root: classes.fieldSet || ''
                    }}
                >
                    { title ? <FormLabel
                        component="legend"
                        classes={{
                            root: classes.titleContainer || ''
                        }}
                    >{ title }</FormLabel> : null }
                    <RadioGroup
                        value={ inputValue }
                        onChange={ onChange }
                        onBlur={ onBlur && (event => onBlur({ id, value: event.target.value })) }
                        onFocus={ onFocus && (event => onFocus({ id, value: event.target.value })) }
                    >
                        { radios }
                    </RadioGroup>
                    { helperText ? <FormHelperText
                        classes={{
                            root: classes.helperContainer || ''
                        }}
                    >{ helperText }</FormHelperText> : null }
                    { errorText ? <FormHelperText
                        classes={{
                            root: classes.errorContainer || ''
                        }}
                    >{ errorText }</FormHelperText> : null }
                </FormControl>
            </React.Fragment>
        );
    }
}

RadioField.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    emptyValue: PropTypes.any,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    options: PropTypes.shape({
        labelPlacement: PropTypes.string
    }),
    valueOptions: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        disabled: PropTypes.bool
    })),
    uiSchema: PropTypes.shape({
        classes: PropTypes.shape({
            fieldSet: PropTypes.string,
            titleContainer: PropTypes.string,
            helperContainer: PropTypes.string,
            errorContainer: PropTypes.string,
            formControlLabel: PropTypes.string,
            radio: PropTypes.string
        })
    }),
    inputValue: PropTypes.any,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    helperText: PropTypes.string,
    onChange: PropTypes.func
};

RadioField.defaultProps = {
    title: '',
    emptyValue: '',
    error: false,
    errorText: '',
    required: false,
    disabled: false,
    options: {
        labelPlacement: 'end'
    },
    valueOptions: [],
    uiSchema: {},
    inputValue: [],
    helperText: ''
};
